// levels.js
const LEVELS = {
    LEVEL_1: {
      ID: "basic",
      VERSION: "1.1",
      BOARD_SIZE: 8, // 8x8 grid
      LEVEL_NAME: "Mfers Jus Getting Started",
      BG_AUDIOS: ["/mfersbeheaded/audio/tvari-tokyo-cafe-159065.mp3"],
      BG_IMAGE: "/images/declarationofcc0.webp",
      BASIC_SOUND: "/mfersbeheaded/audio/cash-register-purchase-87313.mp3",
      TIME_LIMIT: 120,
      LOBESY_ENABLED: true,
      LOBESY_AUDIO: "/mfersbeheaded/audio/voice/sword.mp3",
      IMAGE_MAP: {
            1: '/mfersbeheaded/images/heads/10010.png',  // nngmi zombie
            2: '/mfersbeheaded/images/heads/1704.png',  // nngmi hoodie
            3: '/mfersbeheaded/images/heads/7419.png',  // melted
            4: '/mfersbeheaded/images/heads/6850.png',  // lobesy
            5: '/mfersbeheaded/images/heads/357.png',  // cowboy
            6: '/mfersbeheaded/images/heads/1078.png',  // monocrhome cap
            1001: '/mfersbeheaded/images/heads/5009.png',
            1002: '/mfersbeheaded/images/heads/7041.png',
            1003: '/mfersbeheaded/images/heads//7423.png', // bandana
            1004: '/mfersbeheaded/images/heads/1768.png',
            1005: '/mfersbeheaded/images/heads/1538.png',
            1006: '/mfersbeheaded/images/heads/6598.png',
      },
      ADV_SOUND_CLIPS: [
        '/mfersbeheaded/audio/voice/paco.mp3',
        '/mfersbeheaded/audio/voice/metab.mp3',
        '/mfersbeheaded/audio/voice/spawn.mp3',
        '/mfersbeheaded/audio/voice/discipline.mp3',
      ],
      CREDITS: [
        { key: "Music", value: "Tokyo Cafe by Tavari" },
        { key: "Art", value: "Declaration of CC0 by cryptoW1p0, mfers by sartoshi" },
        { key: "Sound", value: "Metabanas, Discipline, Netspawn, Paco, Shaya" },
      ]
    },
    LEVEL_2: {
      ID: "house_songs",
      VERSION: "1.0",
      BOARD_SIZE: 8, // 8x8 grid
      LEVEL_NAME: "House Songs",
      BG_AUDIOS: ["/mfersbeheaded/audio/northernrains.mp3", "/mfersbeheaded/audio/mysweetpine.mp3", "/mfersbeheaded/audio/coloradotea.mp3"],
      END_AUDIOS: [],
      BG_IMAGE: "/images/housesongs.png",
      BASIC_SOUND: "/mfersbeheaded/audio/cash-register-purchase-87313.mp3",
      TIME_LIMIT: 120,
      LOBESY_ENABLED: true,
      LOBESY_AUDIO: "/mfersbeheaded/audio/voice/sword.mp3",
      IMAGE_MAP: {
        1: '/mfersbeheaded/images/heads/3084.png',  
        2: '/mfersbeheaded/images/heads/4363.png',  // wooly pine
        3: '/mfersbeheaded/images/heads/9184.png',  // pine degen
        4: '/mfersbeheaded/images/heads/2265.png',  // messy purp
        5: '/mfersbeheaded/images/heads/6087.png',  // bandit
        6: '/mfersbeheaded/images/heads/1097.png',  // wooly pine
        1001: '/mfersbeheaded/images/heads/3084-zombie.png',
        1002: '/mfersbeheaded/images/heads/1840.png',
        1003: '/mfersbeheaded/images/heads//9282.png', // bandana
        1004: '/mfersbeheaded/images/heads/2646.png',
        1005: '/mfersbeheaded/images/heads/3515.png',
        1006: '/mfersbeheaded/images/heads/367.png', // wooly zombie
      },
      ADV_SOUND_CLIPS: [
        '/mfersbeheaded/audio/voice/paco.mp3',
        '/mfersbeheaded/audio/voice/metab.mp3',
        '/mfersbeheaded/audio/voice/spawn.mp3',
        '/mfersbeheaded/audio/voice/discipline.mp3',
      ],
      CREDITS: [
        { key: "Music", value: "House Songs by pinedegen" },
        { key: "Artwork", value: "House Songs by Animated Mfers, mfers by Sartoshi" },
        { key: "Sound", value: "Metabanas, Discipline, Netspawn, Paco" },
      ]
    },
      LEVEL_4: {
        ID: "kids_friendly",
        BOARD_SIZE: 8,
        LEVEL_NAME: "Lil Mfers Playground",
        VERSION: "1.0",
        BG_AUDIOS: ["/mfersbeheaded/audio/tvari-tokyo-cafe-159065.mp3"],
        BG_IMAGE: "/images/mfa.png",
        BASIC_SOUND: "/mfersbeheaded/audio/cash-register-purchase-87313.mp3",
        TIME_LIMIT: 300,
        LOBESY_ENABLED: true,
        LOBESY_AUDIO: "/mfersbeheaded/audio/voice/sword.mp3",
        IMAGE_MAP: {
              1: '/mfersbeheaded/images/heads/9058.png',
              2: '/mfersbeheaded/images/heads/9077.png',
              3: '/mfersbeheaded/images/heads/7419.png',
              4: '/mfersbeheaded/images/heads/6406.png',
              5: '/mfersbeheaded/images/heads/9106.png',
              6: '/mfersbeheaded/images/heads/869.png',
              1001: '/mfersbeheaded/images/heads/1090.png',
              1002: '/mfersbeheaded/images/heads/7041.png',
              1003: '/mfersbeheaded/images/heads//7423.png',
              1004: '/mfersbeheaded/images/heads/3926.png',
              1005: '/mfersbeheaded/images/heads/9651.png',
              1006: '/mfersbeheaded/images/heads/3.png',
        },
        ADV_SOUND_CLIPS: [
            "/mfersbeheaded/audio/cash-register-purchase-87313.mp3",
        ],
      },
      LEVEL_5: {
        ID: "nakamigo_crush",
        BOARD_SIZE: 8,
        LEVEL_NAME: "Pixel Crush",
        VERSION: "1.0",
        BG_AUDIOS: ["/mfersbeheaded/audio/tvari-lost-inside.mp3"],
        END_AUDIOS: [],
        BASIC_SOUND: "/mfersbeheaded/audio/correct.mp3",
        TIME_LIMIT: 120,
        LOBESY_ENABLED: true,
        LOBESY_AUDIO: "/mfersbeheaded/audio/voice/sword.mp3",
        IMAGE_MAP: {
              1: '/mfersbeheaded/images/naka/naka6219-nobg.png',
              2: '/mfersbeheaded/images/naka/naka14748-nobg.png',
              3: '/mfersbeheaded/images/naka/naka1877-nobg.png',
              4: '/mfersbeheaded/images/naka/naka1514-nobg.png',
              5: '/mfersbeheaded/images/naka/naka11953-nobg.png',
              6: '/mfersbeheaded/images/naka/naka16327-nobg.png',  
              1001: '/mfersbeheaded/images/naka/naka6219-nobg.png',
              1002: '/mfersbeheaded/images/naka/naka14748-nobg.png',
              1003: '/mfersbeheaded/images/naka/naka1877-nobg.png', 
              1004: '/mfersbeheaded/images/naka/naka1514-nobg.png',
              1005: '/mfersbeheaded/images/naka/naka11953-nobg.png',
              1006: '/mfersbeheaded/images/naka/naka16327-nobg.png',
        },
        ADV_SOUND_CLIPS: [
             "/mfersbeheaded/audio/voice/shaya-nakamigos.mp3", "/mfersbeheaded/audio/voice/success.mp3","/mfersbeheaded/audio/voice/shaya-yowassupmigo.mp3", "/mfersbeheaded/audio/decide.mp3"
        ],
        CREDITS: [
          { key: "Music", value: "Lost Inside by Tavari" },
          { key: "Art", value: "Specific nakas used with permission by Shatt_Eth, Faded Alpha + Soldman Gachs" },
          { key: "Sound", value: "Shaya, Quicksounds.com" },
        ]
      },
      LEVEL_7: {
        ID: "tiny_dino",
        VERSION: "1.0",
        BOARD_SIZE: 8, // 8x8 grid
        LEVEL_NAME: "Let's F'ing Rawr",
        BG_AUDIOS: ["/mfersbeheaded/audio/8BIT_NES-style_byNeuroPop.wav"],
        END_AUDIOS: [],
        BASIC_SOUND: "/mfersbeheaded/audio/cartoon-jump.mp3",
        TIME_LIMIT: 120,
        LOBESY_ENABLED: true,
        BG_IMAGE: "/images/tinydiners.jpeg",
        LOBESY_AUDIO: "/mfersbeheaded/audio/dragon-roar.mp3",
        IMAGE_MAP: {
              1: '/mfersbeheaded/images/tinydinos/transparent/10001.png',
              2: '/mfersbeheaded/images/tinydinos/transparent/skater.png',
              3: '/mfersbeheaded/images/tinydinos/transparent/headphones.png',
              4: '/mfersbeheaded/images/tinydinos/transparent/4684.png',
              5: '/mfersbeheaded/images/tinydinos/transparent/rainbow.png',
              6: '/mfersbeheaded/images/tinydinos/transparent/mfer.png',
              1001: '/mfersbeheaded/images/tinydinos/transparent/10001.png',
              1002: '/mfersbeheaded/images/tinydinos/transparent/skater.png',
              1003: '/mfersbeheaded/images/tinydinos/transparent/headphones.png',
              1004: '/mfersbeheaded/images/tinydinos/transparent/4684.png',
              1005: '/mfersbeheaded/images/tinydinos/transparent/rainbow.png',
              1006: '/mfersbeheaded/images/tinydinos/transparent/mfer.png',
        },
        ADV_SOUND_CLIPS: [],
        CREDITS: [
          { key: "Music", value: "#rawrcade by NeuroPopNFT" },
          { key: "Art", value: "Tiny Diners by JoanZ" },
        ]
      },
  };
  
  export default LEVELS;
  